import React from 'react';
import SolutionScheduleCompleteContainer from 'containers/SolutionScheduleCompleteContainer';

export default function SolutionScheduleCompletePage() {
  return (
    <SolutionScheduleCompleteContainer />
  )
}
